import { ref, onMounted, onUpdated, onBeforeUnmount, type Ref } from 'vue'
// 全文提示及关键字段实际文字宽度，只修改显示属性，不触碰业务数据或事件。
export function useOrderCellTitles(root:Ref<HTMLElement|null|undefined>,enabled:()=>boolean,columns:()=>readonly any[]=()=>[]) {
 const widths=ref<Record<string,number>>({})
 let frame=0,observer:MutationObserver|undefined,resize:ResizeObserver|undefined,stopped=false
 const measure=()=>{frame=0;if(stopped || !enabled() || !root.value)return
  root.value.querySelectorAll<HTMLElement>('td.order-fit-flex,th').forEach(cell=>{
   const value=cell.querySelector<HTMLElement>('.list-order-number')?.title || cell.textContent?.trim() || '';if(cell.title!==value)cell.title=value
  })
  const next:Record<string,number>={}
  // 仅在本轮布局计算内复用；下一轮重新测量，字体或数据变化不沿用旧尺寸。
  let cachedContext:CanvasRenderingContext2D|null|undefined
  const contexts=()=>{if(!cachedContext)cachedContext=document.createElement('canvas').getContext('2d');return cachedContext}
  const measured=new Map<string,Map<string,number>>()
  const measuredWidth=(context:CanvasRenderingContext2D,value:string)=>{
   let values=measured.get(context.font);if(!values){values=new Map();measured.set(context.font,values)}
   const text=String(value);let width=values.get(text)
   if(width===undefined){width=context.measureText(text).width;values.set(text,width)}
   return width
  }
  root.value.querySelectorAll<HTMLElement>('td.order-fit-critical,td.order-fit-time,td.order-fit-short,td.order-fit-flex').forEach(cell=>{
   if(cell.closest('[data-action-scope]')!==root.value || !cell.offsetWidth)return
   const key=cell.dataset.orderFitKey;if(!key)return
   // 分组列用完整查询数据测量，排序/分页只改变行顺序，不改变列宽。
   const column=columns().find(column=>String(column.dataIndex || column.key)===key)
   if(Array.isArray(column?.fitTextValues)){
     if(next[key]!==undefined)return
     const context=contexts(),style=getComputedStyle(cell)
     if(context){
       context.font=`${style.fontWeight} ${style.fontSize} ${style.fontFamily}`
       const textWidth=column.fitTextValues.reduce((width:number,value:string)=>Math.max(width,measuredWidth(context,value)),measuredWidth(context,cell.dataset.orderFitTitle || ''))
       const copy=cell.querySelector<HTMLElement>('.copy-order-button')
       const padding=(parseFloat(style.paddingLeft)||0)+(parseFloat(style.paddingRight)||0)+(copy?copy.offsetWidth+4:0)+4
       // 预留排序双箭头及筛选图标，不随当前排序方向改变。
       next[key]=Math.max(Number(column.width)||0,Math.ceil(textWidth+padding+(column.sorter?18:0)+(column.filterDropdown?18:0)))
     }
     return
   }
   if(cell.classList.contains('order-fit-short') || cell.classList.contains('order-fit-flex')){
     const context=contexts()
     if(context){
       const style=getComputedStyle(cell)
       context.font=`${style.fontWeight} ${style.fontSize} ${style.fontFamily}`
       const content=cell.querySelector<HTMLElement>('.list-text')?.title || cell.textContent?.trim() || ''
       const title=cell.dataset.orderFitTitle || ''
       const width=Math.max(measuredWidth(context,content),measuredWidth(context,title))
       const inlinePhoneCopy=/(phone|mobile|tel)/i.test(key)?cell.querySelector<HTMLElement>('.copy-field-button'):null
       const copyButton=inlinePhoneCopy && getComputedStyle(inlinePhoneCopy).position==='static'?inlinePhoneCopy:cell.querySelector<HTMLElement>('.copy-order-button')
       const copySpace=copyButton?copyButton.offsetWidth+4:0
       const padding=(parseFloat(style.paddingLeft)||0)+(parseFloat(style.paddingRight)||0)+copySpace+4
       next[key]=Math.max(next[key] || 0,Math.ceil(width+padding))
     }
     return
   }
   const scale=cell.getBoundingClientRect().width/cell.offsetWidth || 1
   // 分别量原来的状态块；不把一列中多条状态拼成一个虚假的长字符串。
   const lines=cell.querySelectorAll('div').length?Array.from(cell.querySelectorAll('div')).filter(e=>!e.querySelector('div')):[cell]
   let content=0
   for(const line of lines){const range=document.createRange();range.selectNodeContents(line);content=Math.max(content,range.getBoundingClientRect().width/scale)}
   next[key]=Math.max(next[key] || 0,Math.ceil(content+8))
  })
  if(JSON.stringify(next)!==JSON.stringify(widths.value))widths.value=next
 }
 const schedule=()=>{if(!stopped && enabled() && !frame)frame=requestAnimationFrame(measure)}
 onMounted(()=>{
   if(root.value?.nodeType===1){
     if(typeof MutationObserver!=='undefined'){observer=new MutationObserver(schedule);observer.observe(root.value,{subtree:true,childList:true,characterData:true})}
     if(typeof ResizeObserver!=='undefined'){resize=new ResizeObserver(schedule);resize.observe(root.value)}
   }
   window.addEventListener('resize',schedule);document.fonts?.ready.then(schedule);schedule()
 })
 onUpdated(schedule);onBeforeUnmount(()=>{stopped=true;observer?.disconnect();resize?.disconnect();window.removeEventListener('resize',schedule);if(frame)cancelAnimationFrame(frame)})
 return widths
}
